import React from 'react'
import PropTypes from 'prop-types'
import Input from '@material-ui/core/Input'

const Fields = (props) => {
  const { value: widgetValue, onChange, quoteRef, authorRef, tagsRef } = props

  const onInputChange = (e) => {
    const { name, value } = e.target
    let isImmutableJs = false
    if (typeof widgetValue.get === 'function') isImmutableJs = true

    if (name === 'quoteField') {
      onChange({
        quote: value,
        author: isImmutableJs
          ? widgetValue.get('author')
          : widgetValue.author || null,
        tags:
          typeof widgetValue.get === 'function'
            ? widgetValue.get('tags').toJS()
            : widgetValue.tags || [],
      })
    }
    if (name === 'authorField') {
      onChange({
        author: value,
        quote: isImmutableJs
          ? widgetValue.get('quote')
          : widgetValue.quote || null,
        tags:
          typeof widgetValue.get === 'function'
            ? widgetValue.get('tags').toJS()
            : widgetValue.tags || [],
      })
    }
    if (name === 'tagsField') {
      onChange({
        tags: value.split(/,/).map((str) => str.trim()),
        author: isImmutableJs
          ? widgetValue.get('author')
          : widgetValue.author || null,
        quote:
          typeof widgetValue.get === 'function'
            ? widgetValue.get('quote')
            : widgetValue.quote || null,
      })
    }
  }

  return (
    <div>
      <Input
        name="quoteField"
        placeholder="Quote"
        value={
          typeof widgetValue.get === 'function'
            ? widgetValue.get('quote')
            : widgetValue.quote
        }
        onChange={onInputChange}
        inputRef={quoteRef}
        fullWidth
      />
      <Input
        name="authorField"
        placeholder="Author"
        value={
          typeof widgetValue.get === 'function'
            ? widgetValue.get('author')
            : widgetValue.author
        }
        onChange={onInputChange}
        inputRef={authorRef}
        fullWidth
      />
      <Input
        name="tagsField"
        placeholder="Tags"
        value={
          typeof widgetValue.get === 'function'
            ? widgetValue.get('tags').toJS()
            : widgetValue.tags
        }
        onChange={onInputChange}
        inputRef={tagsRef}
        fullWidth
      />
    </div>
  )
}

Fields.propTypes = {
  value: PropTypes.object.isRequired,
}

export default Fields



// WEBPACK FOOTER //
// ./src/cms/widgets/QuotePicker/Fields.js